import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, Collapse, Form, Input, InputNumber, Row, Select} from "antd";
import ApiService from "../../services/ApiService";
import ContactIcon from "../util-components/ContactIcon";
import {getDevise, getDeviseSymbol} from "../permissions/functions";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";


export default function PromessesListForm({contactId,assoc,onErrored,errored}) {

    const nbPromesses=useRef(0)
    const [data, setData] = useState([])
    const org=useSelector(state=>state.auth.org)

    const getData=async ()=>{
        const res=await ApiService.get("/promesses/contact/"+contactId+"/"+assoc);
        console.log(res)
        setData(res.data)
    }

    useEffect(() => {
        getData()
    }, []);

    if(data.length===0){
        return null
    }

    const devise=org.cerfasInfos.find(i=>i.id===assoc)?.devise || getDevise()

    return (
        <Collapse forceRender style={{marginBottom: 20}}>
            <Collapse.Panel key={0} forceRender header={"Attribuer ce montant à une ou plusieurs promesse(s)"}>

                <Form.List name="dettes">
                    {(fields, {add, remove}) => {
                        nbPromesses.current = fields.length

                        return(
                        <>
                            {fields.map(({key, name, ...restField}) => (
                                <Row key={key} style={{display: 'flex', marginBottom: 8, gap: 20}}>

                                    <Form.Item
                                        {...restField}
                                        label="Promesse de don"
                                        name={[name, 'id']}
                                        rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                    >
                                        <Select style={{minWidth: 300, marginRight: 5, marginBottom: 5}}
                                                placeholder="Choisir une promesses" showSearch
                                                filterOption={(input, option) => {
                                                    var text = option.props.children
                                                    if (Array.isArray(text)) {
                                                        text = text.join("")
                                                    }
                                                    return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }}
                                        >
                                            {data.map((item, index) => {
                                                return(
                                                    <Select.Option key={index} value={item.id}>
                                                        {item.occasion && "("+item.occasion+") -"} {item.name} {item.reste}{getDeviseSymbol(devise)}
                                                    </Select.Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>


                                    <Form.Item noStyle shouldUpdate>
                                        {(form)=>{
                                            let max=undefined

                                            const detteId=form.getFieldValue(["dettes",name,"id"])
                                            //console.log(detteId)
                                            if(detteId){
                                                const dette=data.find(i=>i.id===detteId)
                                                if(dette){
                                                    max=dette.reste
                                                }
                                            }
                                            //console.log("max",max)

                                            return(
                                                <Form.Item
                                                    {...restField}
                                                    label="Montant"
                                                    name={[name, 'montant']}
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <InputNumber
                                                        decimalSeparator={','} min={1} max={max}
                                                        step={0.5}
                                                        addonAfter={getDeviseSymbol(devise)}
                                                    />
                                                </Form.Item>
                                            )
                                        }}
                                    </Form.Item>

                                    <Button danger icon={<MinusCircleOutlined/>}
                                            onClick={() => remove(name)}/>

                                </Row>
                            ))}
                            <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                    Ajouter une Promesse au paiement
                                </Button>
                            </Form.Item>


                            <Form.Item noStyle shouldUpdate>
                                {(form)=>{

                                    const globalMontant=form.getFieldValue("montant")

                                    let totalPromesseMontant=0
                                    for(let i=0;i<nbPromesses.current;i++){
                                        const t=form.getFieldValue(["dettes",i,"montant"])
                                        totalPromesseMontant+=t
                                    }

                                    //console.log(globalMontant,totalPromesseMontant)

                                    if(globalMontant>=totalPromesseMontant){
                                        if(onErrored && errored) {
                                            onErrored(false)
                                        }
                                        return null
                                    }

                                    if(onErrored && !errored) {
                                        onErrored(true)
                                    }

                                    return(
                                        <div style={{marginTop:20,marginBottom:20}}>
                                            <Alert
                                                showIcon
                                                type="error"
                                                message={"Attention !"}
                                                description={"Les montants des promesses de don sont supérieurs au montant du paiement lui-même !"}
                                            />
                                        </div>
                                    )
                                }}
                            </Form.Item>
                        </>
                        )
                    }}
                </Form.List>
            </Collapse.Panel>
        </Collapse>
    )
}
